/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

angular.module('bulbApp.contentEditorModule')
.controller('AudioBlockController', ['$scope','$timeout','BulbBrowserService','CONFIG','CONTENT_EDITOR', AudioBlockController]);

function AudioBlockController($scope, $timeout, BulbBrowserService, CONFIG, CONTENT_EDITOR) {
  var that = this;

  this.width = CONFIG.page.content.max.width;
  this.height = 45;
  this.isMobile = BulbBrowserService.isMobile();


  this.updateAudioSize = function () {
    // update the width:
    var contentSize = jQuery('.bulb-page-content').width();
    var maxSize = CONFIG.page.content.max.width;
    var scale = contentSize / maxSize;
    that.width = $scope.contentBlockCtrl.contentBlock.width * scale;

    // jplayer doesn't allow for dynamic resizing of the audio container, so that is why we need to explicitly
    // set the width.
    // So we are going to set this based off a percentage of the content max width.
    $timeout( function() {

      if (that.isMobile) {
        // Update the page content max width so that it fits correctly on all devices
        maxSize = maxSize * scale;
        that.width = maxSize * CONTENT_EDITOR.MOBILE_AUDIO_BLOCK_WIDTH_PERCENTAGE;
        // Since jplayer uses pure scss to size the player, we need to grab the player and update the width dynamically
        $timeout( function() {
          jQuery('.jp-audio').css('width', that.width);
        });

        // Update the value on the contentBlock controller
        $scope.contentBlockCtrl.contentBlock.width = that.width;

      }

    }, CONTENT_EDITOR.MOBILE_AUDIO_BLOCK_SET_WIDTH_TIMEOUT);

    // Determines if the width of the video block is larger than what we allow for content to the go to the right or
    // left on a right/left align.
    $scope.contentBlockCtrl.isFullWidth = ($scope.contentBlockCtrl.contentBlock.width >
      (maxSize * CONTENT_EDITOR.FULL_BLOCK_WIDTH_PERCENTAGE));
  };


  $scope.$watchCollection('contentBlockCtrl.contentBlock', function () {
    that.updateAudioSize();
  });

}


